export default __webpack_public_path__ + "static/media/travelwell.772033dc.png";